import React, { useContext } from "react";
import { Layout, Card, TextField, BlockStack, Text } from "@shopify/polaris";

// import context
import { PrivateContext } from "lib/context";

// import components
import ImageComponent from "lib/components/dropZone/dropZone";

const BrandSection = () => {
  const { cms = {} } = useContext(PrivateContext);
  const getFields = () => {
    return (
      <>
        <TextField
          label={cms("section.brand.label.name")}
          placeholder={cms("section.brand.placeHolder.name")}
          value=""
          disabled
        />
        <br />
        <TextField
          label={cms("section.brand.label.handle")}
          placeholder={cms("section.brand.placeHolder.handle")}
          value=""
          disabled
        />
        <br />
        <TextField
          label={cms("section.brand.label.description")}
          placeholder={cms("section.brand.placeHolder.description")}
          value=""
          multiline={4}
          disabled
        />
        <br />
        <span>{cms("section.brand.label.logo")}</span>
        <ImageComponent size={10} disabled />
        <br />
        <span>{cms("section.brand.label.cover")}</span>
        <ImageComponent size={10} disabled />
      </>
    );
  };
  return (
    <Layout.AnnotatedSection title={cms("section.brand.title")} description={cms("section.brand.description")}>
      <Card>
        <Text as="h6" variant="headingSm">
          {cms("section.brand.subTitle")}
        </Text>
        <Text as="p">{cms("section.brand.subDescription")}</Text>
        <BlockStack>
          <br />
          {getFields()}
        </BlockStack>
      </Card>
    </Layout.AnnotatedSection>
  );
};

export default BrandSection;
